module.exports = __webpack_public_path__ + "static/media/pho.0ebd5109.ogg";